import React from "react";
import { useQuery } from "react-query";
import { getReportsToEmployeesOption } from "../../../../../actions/Employees";

export const useGetReportsToEmployees = () => {
  return useQuery("GetReportsToEmployeesOption", getReportsToEmployeesOption, {
    refetchOnWindowFocus: false,
  });
};
